import './Aboutme.css';

const Aboutme = () => {
  return (
    <div id="aboutme" className="container-about">
        <div className="aboutme">
                <h2>Um cara apaixonado por tecnologia e inovação!</h2>
            <div className='line-about'></div>
                <p>Olá! Meu nome é Lucas e sou um desenvolvedor afixionado por solucionar problemas e criar soluções inovadoras. Acredito que a tecnologia é uma das coisas que pode mudar o mundo e sempre busco maneiras de contribuir para esse objetivo.</p>
        </div>
    </div>
  );
};
export default Aboutme;